module.exports = __webpack_public_path__ + "img/rdw-4.ff9ed43a.jpg";